import styled from '@emotion/styled'

export const StyleGroupRadioItems = styled.div`
  display: flex;
  flex-flow: row wrap;
  row-gap: 20px;
  column-gap: 30px;
  align-items: center;
`

export const StyleGroupRadioItem = styled.div`
  display: flex;
  align-items: center;
  column-gap: 5px;
`

export const StyleRadio = styled.input``

export const StyleRadioLabel = styled.p`
  font-size: 14px;
  color: #000;
`
